import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock8 as Block } from "./HomepageBlock8";
import { defaultData } from "./HomepageBlock8DefaultData";
import { meta } from "./HomepageBlock8MetaData";
import imagePreview from "./homepage_block_8_preview.png";

export const HomepageBlock8: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
